import React from "react";
import PropTypes from "prop-types";
import "./HourglassLoader.css";

const DEFAULT_LOGO = "/assets/images/logo-itev-white.png";

/**
 * Loader unificado do app (logo com flip 3D + glow).
 *
 * Sem `progress`  → modo indeterminado (label + dots pulsando).
 * Com `progress`  → barra determinística + "{current} de {total} — {detail}" + %.
 *   progress = { current: number, total: number, detail?: string }
 */
const HourglassLoader = ({
  logoSrc = DEFAULT_LOGO,
  cycleSeconds = 2,
  size = 188,
  background = "#081730",
  fullscreen = true,
  label = "Carregando",
  progress = null,
}) => {
  const flipDur = `${cycleSeconds * 2}s`;
  const pct =
    progress && progress.total > 0
      ? Math.min(100, Math.round((progress.current / progress.total) * 100))
      : 0;

  return (
    <div
      className={`hourglass-loader ${
        fullscreen ? "hourglass-loader--fullscreen" : "hourglass-loader--fill"
      }`}
      style={{ background }}
    >
      <div className="hourglass-loader__stage">
        <span
          className="hourglass-loader__glow"
          style={{
            width: size * 1.1,
            height: size * 1.1,
            animationDuration: flipDur,
          }}
        />
        <div className="hourglass-loader__perspective">
          <img
            src={logoSrc}
            alt=""
            className="hourglass-loader__logo"
            style={{ width: size, animationDuration: flipDur }}
          />
        </div>
      </div>

      {label && (
        <div className="hourglass-loader__label">
          <span>{label}</span>
          {progress ? (
            <span className="hourglass-loader__pct">{pct}%</span>
          ) : (
            <span className="hourglass-loader__dots">
              {[0, 0.2, 0.4].map((d) => (
                <i key={d} style={{ animationDelay: `${d}s` }} />
              ))}
            </span>
          )}
        </div>
      )}

      {progress && (
        <div className="hourglass-loader__progress">
          <div className="hourglass-loader__track">
            <div
              className="hourglass-loader__fill"
              style={{ width: `${pct}%` }}
            />
          </div>
          <div className="hourglass-loader__detail">
            {progress.current} de {progress.total}
            {progress.detail ? ` — ${progress.detail}` : ""}
          </div>
        </div>
      )}
    </div>
  );
};

HourglassLoader.propTypes = {
  logoSrc: PropTypes.string,
  cycleSeconds: PropTypes.number,
  size: PropTypes.number,
  background: PropTypes.string,
  fullscreen: PropTypes.bool,
  label: PropTypes.string,
  progress: PropTypes.shape({
    current: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    detail: PropTypes.string,
  }),
};

export default HourglassLoader;
